import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SlidersHorizontal } from "@phosphor-icons/react";
import { ModelPicker } from "@/components/ModelPicker";

export function ToolChips({ tools, value, onChange, testPrefix = "target" }) {
  return (
    <div className="stp-noscroll -mx-1 flex gap-2 overflow-x-auto px-1 py-1" data-testid={`${testPrefix}-chips`}>
      {tools.map((t) => (
        <button
          key={t.id}
          data-testid={`${testPrefix}-chip-${t.id}`}
          onClick={() => onChange(t.id)}
          className={`shrink-0 rounded-full px-4 py-2 text-[13px] font-medium transition-colors ${
            value === t.id ? "bg-ink text-white" : "bg-white text-ink shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)] hover:bg-black/5"
          }`}
        >
          {t.label.replace(" / Any", "")}
        </button>
      ))}
    </div>
  );
}

export function TargetSelect({ tools, value, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="h-10 rounded-xl border-black/10 bg-white text-sm"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-72 rounded-xl">
        {tools.map((t) => <SelectItem key={t.id} value={t.id}>{t.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function EnginePopover({ providers, provider, model, onProvider, onModel }) {
  const label = providers?.[provider]?.models?.find((m) => m.id === model)?.label || model;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="engine-settings-button" className="flex h-9 items-center gap-1.5 rounded-full bg-black/5 px-3.5 text-xs font-medium text-ink hover:bg-black/10">
          <SlidersHorizontal size={14} weight="bold" /> Written by <span className="text-brand">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 rounded-2xl p-4">
        <p className="mb-3 text-xs text-mist">Pick which AI writes your prompt. The default works great for most ideas.</p>
        <ModelPicker providers={providers} provider={provider} model={model} onProvider={onProvider} onModel={onModel} idPrefix="main" />
      </PopoverContent>
    </Popover>
  );
}
